import { updateTagLink } from 'api/Tags';

const { showAlert } = require('components/shared/Alert/Alert');

export const updateTagLinks = async ({
  navigate = null,
  queryClient = null,
  id = null,
  tags = [],
  mode = '',
  query = {},
  fromTable = false,
  refTable = '',
  isInvalidate = false
}) => {
  try {
    const result = await updateTagLink(navigate, {
      id,
      tags,
      mode,
      refTable
    });
    if (result?.code === 0) {
      if (!fromTable) {
        const queryUpdate = (oldData) => {
          try {
            const newData = oldData?.[query?.object]?.map((p) => {
              if (p?.id !== parseInt(id)) {
                return p;
              }

              let newTags = structuredClone(p.tagLinks || []);
              if (mode === 'remove') {
                newTags = newTags.filter(
                  (tag) => !result.tags.some((r) => r.tag_id === tag?.tag_id)
                );
              }
              if (mode === 'add') {
                const addedTags = result?.tags?.flatMap((t) => t);
                const uniqueTags = addedTags.filter(
                  (newTag) => !newTags.some((existing) => existing?.tag_id === newTag?.tag_id)
                );
                newTags = [...newTags, ...uniqueTags];
              }
              if (mode === 'update') {
                const addedTags = result?.tags?.flatMap((t) => t);
                const filterOldPositions = newTags?.filter(
                  (tag) => !addedTags.some((addedTag) => addedTag?.tag_id === tag?.tag_id)
                );
                newTags = [...filterOldPositions, ...addedTags];
              }

              return {
                ...p,
                tagLinks: newTags
              };
            });

            return {
              ...oldData,
              [query?.object]: newData
            };
          } catch (error) {
            showAlert({
              title: 'Tags update failed',
              message: error ?? 'Something went wrong',
              color: 'danger'
            });
          }
        };
        if (!isInvalidate) {
          if (query.multiple) {
            query?.keys?.forEach((key) => {
              queryClient.setQueriesData(key, queryUpdate);
            });
          } else {
            queryClient.setQueriesData(query?.keys, queryUpdate);
          }
        } else {
          if (query.multiple) {
            query?.keys?.forEach((key) => {
              queryClient.invalidateQueries(key);
            });
          } else {
            queryClient.invalidateQueries(query?.keys);
          }
        }
      } else {
        if (query.multiple) {
          query?.keys?.forEach((key) => {
            queryClient.invalidateQueries(key);
          });
        } else {
          queryClient.invalidateQueries(query?.keys);
        }
      }
    }
  } catch (error) {
    showAlert({
      title: 'Tags update failed',
      message: error ?? 'Something went wrong',
      color: 'danger'
    });
  }
};
